import { useField } from 'formik'
import React from 'react'

import InputTextField from './InputTextField'

export type FormFieldProps = React.InputHTMLAttributes<HTMLInputElement> & {
  name: string
  validate?: () => void
  subtext?: React.ReactNode
  noLeftRadius?: boolean
  required?: boolean
  placeholder?: string
  label?: string
  onBlur?: (e: React.FocusEvent<HTMLElement>) => void
}

const FormField: React.FC<FormFieldProps> = ({
  name,
  validate,
  subtext,
  ...props
}) => {
  const [fieldProps, { touched, error }] = useField({ name, validate })
  return (
    <InputTextField
      {...fieldProps}
      isInvalid={error && touched}
      subtext={error && touched ? error : subtext}
      {...props}
    />
  )
}

export default FormField
